import { render } from "./external-relay.vue?vue&type=template&id=102abc3e&ts=true"
import script from "./external-relay.vue?vue&type=script&lang=ts"
export * from "./external-relay.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__